// Auto-generated diagnosis rules
export const diagnosisRules = [
  {
    "keywords": [
      "fever"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "fever"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "fever"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "cough"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "shortness of breath"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "shortness of breath"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "shortness of breath"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "abdominal pain"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "abdominal pain"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "abdominal pain"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "diarrhea"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "diarrhea"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "diarrhea"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "vomiting"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "vomiting"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "vomiting"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "jaundice"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "jaundice"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "jaundice"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "headache"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "headache"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "headache"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "palpitations"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  },
  {
    "keywords": [
      "palpitations"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  },
  {
    "keywords": [
      "palpitations"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  },
  {
    "keywords": [
      "fever",
      "cough"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Malaria",
      "Pneumonia"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "fever",
      "cough"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Malaria",
      "Pneumonia"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "fever",
      "cough"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Malaria",
      "Pneumonia"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "fever",
      "rash"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Dengue",
      "Viral Exanthem"
    ],
    "suggestedProcedures": [
      "Dengue RDT",
      "CBC"
    ]
  },
  {
    "keywords": [
      "fever",
      "rash"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Dengue",
      "Viral Exanthem"
    ],
    "suggestedProcedures": [
      "Dengue RDT",
      "CBC"
    ]
  },
  {
    "keywords": [
      "fever",
      "rash"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Dengue",
      "Viral Exanthem"
    ],
    "suggestedProcedures": [
      "Dengue RDT",
      "CBC"
    ]
  },
  {
    "keywords": [
      "abdo",
      "pain",
      "vomiting"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis"
    ],
    "suggestedProcedures": [
      "Abdominal ultrasound",
      "IV fluids"
    ]
  },
  {
    "keywords": [
      "abdo",
      "pain",
      "vomiting"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis"
    ],
    "suggestedProcedures": [
      "Abdominal ultrasound",
      "IV fluids"
    ]
  },
  {
    "keywords": [
      "abdo",
      "pain",
      "vomiting"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis"
    ],
    "suggestedProcedures": [
      "Abdominal ultrasound",
      "IV fluids"
    ]
  },
  {
    "keywords": [
      "cough",
      "sputum"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Bacterial pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Sputum culture",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough",
      "sputum"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Bacterial pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Sputum culture",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough",
      "sputum"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Bacterial pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Sputum culture",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "short",
      "breath",
      "wheeze"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Asthma",
      "Bronchiolitis"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Steroids"
    ]
  },
  {
    "keywords": [
      "short",
      "breath",
      "wheeze"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Asthma",
      "Bronchiolitis"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Steroids"
    ]
  },
  {
    "keywords": [
      "short",
      "breath",
      "wheeze"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Asthma",
      "Bronchiolitis"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Steroids"
    ]
  },
  {
    "keywords": [
      "fever",
      "variant0"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "fever",
      "variant1"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "fever",
      "variant2"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "cough",
      "variant3"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough",
      "variant4"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough",
      "variant5"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "shortness of breath",
      "variant6"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "shortness of breath",
      "variant7"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "shortness of breath",
      "variant8"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "abdominal pain",
      "variant9"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "abdominal pain",
      "variant10"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "abdominal pain",
      "variant11"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "diarrhea",
      "variant12"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "diarrhea",
      "variant13"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "diarrhea",
      "variant14"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "vomiting",
      "variant15"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "vomiting",
      "variant16"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "vomiting",
      "variant17"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "jaundice",
      "variant18"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "jaundice",
      "variant19"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "jaundice",
      "variant20"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "headache",
      "variant21"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "headache",
      "variant22"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "headache",
      "variant23"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain",
      "variant24"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain",
      "variant25"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain",
      "variant26"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "palpitations",
      "variant27"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  },
  {
    "keywords": [
      "palpitations",
      "variant28"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  },
  {
    "keywords": [
      "palpitations",
      "variant29"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  },
  {
    "keywords": [
      "fever",
      "cough",
      "variant30"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Malaria",
      "Pneumonia"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "fever",
      "cough",
      "variant31"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Malaria",
      "Pneumonia"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "fever",
      "cough",
      "variant32"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Malaria",
      "Pneumonia"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "fever",
      "rash",
      "variant33"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Dengue",
      "Viral Exanthem"
    ],
    "suggestedProcedures": [
      "Dengue RDT",
      "CBC"
    ]
  },
  {
    "keywords": [
      "fever",
      "rash",
      "variant34"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Dengue",
      "Viral Exanthem"
    ],
    "suggestedProcedures": [
      "Dengue RDT",
      "CBC"
    ]
  },
  {
    "keywords": [
      "fever",
      "rash",
      "variant35"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Dengue",
      "Viral Exanthem"
    ],
    "suggestedProcedures": [
      "Dengue RDT",
      "CBC"
    ]
  },
  {
    "keywords": [
      "abdo",
      "pain",
      "vomiting",
      "variant36"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis"
    ],
    "suggestedProcedures": [
      "Abdominal ultrasound",
      "IV fluids"
    ]
  },
  {
    "keywords": [
      "abdo",
      "pain",
      "vomiting",
      "variant37"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis"
    ],
    "suggestedProcedures": [
      "Abdominal ultrasound",
      "IV fluids"
    ]
  },
  {
    "keywords": [
      "abdo",
      "pain",
      "vomiting",
      "variant38"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis"
    ],
    "suggestedProcedures": [
      "Abdominal ultrasound",
      "IV fluids"
    ]
  },
  {
    "keywords": [
      "cough",
      "sputum",
      "variant39"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Bacterial pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Sputum culture",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough",
      "sputum",
      "variant40"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Bacterial pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Sputum culture",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough",
      "sputum",
      "variant41"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Bacterial pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Sputum culture",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "short",
      "breath",
      "wheeze",
      "variant42"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Asthma",
      "Bronchiolitis"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Steroids"
    ]
  },
  {
    "keywords": [
      "short",
      "breath",
      "wheeze",
      "variant43"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Asthma",
      "Bronchiolitis"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Steroids"
    ]
  },
  {
    "keywords": [
      "short",
      "breath",
      "wheeze",
      "variant44"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Asthma",
      "Bronchiolitis"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Steroids"
    ]
  },
  {
    "keywords": [
      "fever",
      "variant0",
      "variant45"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "fever",
      "variant1",
      "variant46"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "fever",
      "variant2",
      "variant47"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Malaria",
      "Typhoid Fever",
      "Viral Febrile Illness"
    ],
    "suggestedProcedures": [
      "Malaria RDT",
      "CBC",
      "Paracetamol",
      "ORS"
    ]
  },
  {
    "keywords": [
      "cough",
      "variant3",
      "variant48"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough",
      "variant4",
      "variant49"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "cough",
      "variant5",
      "variant50"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "URTI",
      "Pneumonia",
      "Bronchitis"
    ],
    "suggestedProcedures": [
      "Chest X-ray",
      "Nebulization",
      "Antibiotics"
    ]
  },
  {
    "keywords": [
      "shortness of breath",
      "variant6",
      "variant51"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "shortness of breath",
      "variant7",
      "variant52"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "shortness of breath",
      "variant8",
      "variant53"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Asthma Exacerbation",
      "Pneumonia",
      "COPD Exacerbation"
    ],
    "suggestedProcedures": [
      "Nebulization",
      "Oxygen Therapy",
      "Chest X-ray"
    ]
  },
  {
    "keywords": [
      "abdominal pain",
      "variant9",
      "variant54"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "abdominal pain",
      "variant10",
      "variant55"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "abdominal pain",
      "variant11",
      "variant56"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Gastroenteritis",
      "Appendicitis",
      "Peptic Ulcer Disease"
    ],
    "suggestedProcedures": [
      "Abdominal Ultrasound",
      "IV Fluids",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "diarrhea",
      "variant12",
      "variant57"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "diarrhea",
      "variant13",
      "variant58"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "diarrhea",
      "variant14",
      "variant59"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Food Poisoning"
    ],
    "suggestedProcedures": [
      "ORS",
      "Stool M/C",
      "Rehydration"
    ]
  },
  {
    "keywords": [
      "vomiting",
      "variant15",
      "variant60"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "vomiting",
      "variant16",
      "variant61"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "vomiting",
      "variant17",
      "variant62"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Acute Gastroenteritis",
      "Gastritis"
    ],
    "suggestedProcedures": [
      "Antiemetic",
      "IV Fluids"
    ]
  },
  {
    "keywords": [
      "jaundice",
      "variant18",
      "variant63"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "jaundice",
      "variant19",
      "variant64"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "jaundice",
      "variant20",
      "variant65"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Hepatitis",
      "Hemolysis"
    ],
    "suggestedProcedures": [
      "LFTs",
      "Viral Hepatitis Panel"
    ]
  },
  {
    "keywords": [
      "headache",
      "variant21",
      "variant66"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "headache",
      "variant22",
      "variant67"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "headache",
      "variant23",
      "variant68"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "Tension Headache",
      "Migraine",
      "Meningitis"
    ],
    "suggestedProcedures": [
      "Neuro exam",
      "CT head if focal",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain",
      "variant24",
      "variant69"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain",
      "variant25",
      "variant70"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "chest pain",
      "variant26",
      "variant71"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "ACS",
      "Musculoskeletal chest pain",
      "Pericarditis"
    ],
    "suggestedProcedures": [
      "ECG",
      "Cardiac enzymes",
      "Analgesia"
    ]
  },
  {
    "keywords": [
      "palpitations",
      "variant27",
      "variant72"
    ],
    "ageGroup": "adult",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  },
  {
    "keywords": [
      "palpitations",
      "variant28",
      "variant73"
    ],
    "ageGroup": "pediatric",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  },
  {
    "keywords": [
      "palpitations",
      "variant29",
      "variant74"
    ],
    "ageGroup": "both",
    "possibleDiagnosis": [
      "SVT",
      "Anxiety",
      "Arrhythmia"
    ],
    "suggestedProcedures": [
      "ECG",
      "Holter monitor",
      "Electrolytes"
    ]
  }
];
